import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UpfrontPercentageState {
  value?: string;
}

const initialState: UpfrontPercentageState = {
  value: '',
};

const upfrontPercentageSlice = createSlice({
  name: 'upfrontPercentage',
  initialState,
  reducers: {
    setUpfrontPercentage: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setUpfrontPercentage } = upfrontPercentageSlice.actions;
export default upfrontPercentageSlice.reducer;
